/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum UserRole {
    SYSTEM_ADMIN = 'system_admin',
    CLIENT_ADMIN = 'client_admin',
    TEAM_LEAD = 'team_lead',
    USER = 'user',
    SERVICE = 'service',
}
